import React from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { registerModal, CloseModal, useModal } from '@gluedigital/modal'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import MarkdownMessage from '@gluedigital/markdown-message'

import './DeleteVisit.sass'
import { requestVisitDeletion } from '../../store/actions/api'

const DeleteVisit = ({ visitId, businessId }) => {
  const modal = useModal()
  const dispatch = useDispatch()

  const handleRequestDeleteVisit = () => {
    dispatch(requestVisitDeletion(visitId, businessId))
    modal.hide()
  }

  return (
    <div className="delete-visit">
      <h1>
        <MarkdownMessage id="delete-visit.title" />
      </h1>
      <Link className="cancel link" to="/">
        <button className="delete" onClick={handleRequestDeleteVisit}>
          <FormattedMessage id="yes" />
        </button>
      </Link>
      <CloseModal tagName="button">
        <FormattedMessage id="no" />
      </CloseModal>
    </div>
  )
}

DeleteVisit.propTypes = {
  visitId: PropTypes.number.isRequired,
  businessId: PropTypes.number.isRequired
}

registerModal('delete-visit', DeleteVisit)
